import React, { createContext, useContext } from "react"

import { SelectOption } from "shared/types/Select"

import { NullablePrice } from "features/product-position-management/types/ProductPositionFormOptions"

export interface ProductPositionFormPriceContextValue {
  price?: NullablePrice | null
  isPriceOverwritten?: boolean
  isPriceGroupOverwritten?: boolean
  isSpecialPriceGroup?: boolean
  isPriceGroupEditable?: boolean
  isUnitPriceEditable?: boolean
  isPriceServiceAvailable?: boolean
  hideSpecialPriceGroupToggle?: boolean
  priceGroupOptions?: SelectOption<string>[]
}

const ProductPositionFormPriceContext = createContext<
  ProductPositionFormPriceContextValue | undefined
>(undefined)

export interface ProductPositionFormPriceProviderProps {
  value: ProductPositionFormPriceContextValue
  children: React.ReactNode
}

export const ProductPositionFormPriceProvider = React.memo(
  ({ value, children }: ProductPositionFormPriceProviderProps) => (
    <ProductPositionFormPriceContext.Provider value={value}>
      {children}
    </ProductPositionFormPriceContext.Provider>
  )
)

export function useProductPositionFormPriceContext(): ProductPositionFormPriceContextValue {
  const context = useContext(ProductPositionFormPriceContext)
  if (!context) {
    throw new Error(
      "useProductPositionFormPriceContext must be used within a ProductPositionFormPriceProvider"
    )
  }
  return context
}
